/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * CustomerObject Status
 */
export enum CustomerObjectProfileStatusEnum {
    ACTIVE = 'ACTIVE',
    PASSIVE = 'PASSIVE',
    DELETED = 'DELETED',
}